import React, {PropsWithChildren, useEffect, useRef} from 'react';
import withAuthentication from '@/middleware/authentication';
import {observer} from 'mobx-react-lite';
import {useRouter, usePathname} from 'next/navigation';
import {useStore} from '@/store/root-store';
import {publicPages} from '@/utils/const';
import {NoSsr} from '../common-components';
import Header from './header';
import {MainLoader} from '../common-components';
import {getTokenFromCookies} from '@/api/common-utils';

export const languages = (locale:string) =>{
  const languageObj = {
    'en': ' English(US)',
    'es': 'Español',
  };

  return languageObj[locale];
};

type PublicLayoutProps = {
  children: React.ReactNode;
};

export const PublicLayout: React.FC<PublicLayoutProps> = observer(({children}) => {
  const router = useRouter();
  const path = usePathname();
  const contentRef = useRef(null);
  useEffect(() => {
    if (path === '/') {
      router.push('/login');
    }
  }, [path, router]);
  return <div style={{overflowX: 'hidden', minHeight: '100vh'}}>
    <div style={{display: 'flex'}}>
      <div style={{flex: 1, transition: 'all 0.2s ease', maxWidth: '100%'}} ref={contentRef}>{children}</div>
    </div>
  </div>;
});

type PrivateLayoutProps = PropsWithChildren<{}>;

export const PrivateLayout: React.FC<PrivateLayoutProps> = withAuthentication(
  observer<PrivateLayoutProps>(({children}) => {
    const contentRef = useRef(null);

    return (
      <div style={{overflow: 'hidden', minHeight: '100vh'}}>
        <Header/>
        <div style={{display: 'flex', marginTop: '50px'}}>
          {/* <div style={{height: 'auto', background: '#24262A', borderRight: path == '/home' ? '1px solid #4E515680' : '0'}}>
            {typeof window !== 'undefined' &&
                <Sidebar sideBarItems={sideBarItems} publicPage={false}/>
            }
          </div> */}
          <div style={{flexGrow: '1', transition: 'all 0.2s ease', overflow: 'hidden'}} ref={contentRef}>
            <div>{children}</div>
          </div>
        </div>
      </div>
    );
  }),
);

type LayoutProps = {
  children: React.ReactNode;
};

export const Layout = observer<LayoutProps>(({children}) => {
  const {settings: {customer: {loadProfile, profile: {customerId}, loadQuota}}} = useStore('');
  const router = useRouter();
  const path = usePathname();
  const token = getTokenFromCookies();

  useEffect(() => {
    if (!token) {
      loadProfile();
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  useEffect(() => {
    if (customerId) {
      loadQuota(customerId);
    }
  }, [JSON.stringify(customerId)]);

  useEffect(() => {
    if (!token && !publicPages.includes(path)) {
      router.push('/login');
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path]);

  return path === '/' ? <MainLoader fullPage={true} /> : publicPages.includes(path) ? (
    <NoSsr>
      <PublicLayout>{children}</PublicLayout>
    </NoSsr>
  ) : (
    <NoSsr>
      {getTokenFromCookies() ? <PrivateLayout>{children}</PrivateLayout> : <MainLoader fullPage={true} />}
    </NoSsr>
  );
});
